import { useRatebooks } from '@api/useFreight/useFreight'
import type { Ratebook } from '@api/useFreight/types'
import { useLocalStorage } from '@gravitate-js/excalibrr'
import * as React from 'react'
import { useParams } from 'react-router-dom'

export function useRatebookDrillIn() {
  const params = useParams()
  const ratebookId = params.id || ''
  const { useRatebookQuery } = useRatebooks()
  const { data: selectedRatebook, isLoading } = useRatebookQuery(ratebookId)

  // Track invoice status
  const [invoiceStatus, setInvoiceStatus] = React.useState<string>(selectedRatebook?.invoice_status || '')

  // Use localStorage to save and restore the active tab
  const storageKey = `ratebook-${ratebookId}-active-tab`
  const { value: activeTab, setValue: setActiveTab } = useLocalStorage<string>(storageKey, 'invoice-configuration')

  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTab(key)
  }

  // Update invoice status when ratebook changes
  React.useEffect(() => {
    if (selectedRatebook?.invoice_status) {
      setInvoiceStatus(selectedRatebook.invoice_status)
    }
  }, [selectedRatebook])

  return {
    ratebookId,
    selectedRatebook,
    isLoading,
    invoiceStatus,
    setInvoiceStatus,
    activeTab,
    handleTabChange,
  }
}
